import {ApiService, CrudService} from '../services/';

export const fetchPlaces = async (params) => {

    // get from
    const url = params.from;

    // clear url
    delete params.from;

    if(params.q){
        params.q = params.q.replace(' ', '*');
    }

    // fetch
    return ApiService({
        url,
        params
    });
};

export const getPlace = (from, place_id) => {
    return ApiService({
        url: `${from}/${place_id}`
    });
};

export const putPlaces = (data) => {
    return CrudService._put({
        url: `v1/places/edit/${data.id}`,
        data
    });
};

export const postPlaces = (data) => {
    const id = data.get('id');

    return CrudService._post({
        url: `v1/places/edit/${id}`,
        data
    });
};

export const postSupport = (data) => {
    return CrudService._post({
        url: `v1/places/support/${data.place_id}/${data.course_id}`,
        data
    });
};